const escapeHtml = require('stringify-entities').escape;

function setSharingScript(state) {
  state.md.helperScripts.add('https://kamigame.jp/kamigame-twitter-sharing/js/share-modal.js');
}

const enqueteCommand = {};

enqueteCommand.enquete = (state, title, startTime, ...args) => {
  setSharingScript(state);
  return `<div class="enquete-wrapper" data-title="${escapeHtml(title)}" data-start-time="${escapeHtml(startTime)}" data-enquete-items="${escapeHtml(JSON.stringify(args))}" data-select-num="1"></div>`;
};

enqueteCommand.multi_enquete = (state, title, startTime, selectNum, ...args) => {
  setSharingScript(state);
  return `<div class="enquete-wrapper" data-title="${escapeHtml(title)}" data-start-time="${escapeHtml(startTime)}" data-enquete-items="${escapeHtml(JSON.stringify(args))}" data-select-num="${escapeHtml(selectNum)}" ></div>`;
};

enqueteCommand.enquete_with_period = (state, title, startTime, endTime, ...args) => {
  setSharingScript(state);
  return `<div class="enquete-wrapper" data-title="${escapeHtml(title)}" data-start-time="${escapeHtml(startTime)}" data-end-time="${escapeHtml(endTime)}" data-enquete-items="${escapeHtml(JSON.stringify(args))}" data-select-num="1"></div>`;
};

enqueteCommand.multi_enquete_with_period = (state, title, startTime, endTime, selectNum, ...args) => {
  setSharingScript(state);
  return `<div class="enquete-wrapper" data-title="${escapeHtml(title)}" data-start-time="${escapeHtml(startTime)}" data-end-time="${escapeHtml(endTime)}" data-enquete-items="${escapeHtml(JSON.stringify(args))}" data-select-num="${escapeHtml(selectNum)}" ></div>`;
};

enqueteCommand.sharing_enquete = (state, title, startTime, ...args) => {
  setSharingScript(state);
  return `<div class="enquete-wrapper" data-title="${escapeHtml(title)}" data-start-time="${escapeHtml(startTime)}" data-enquete-items="${escapeHtml(JSON.stringify(args))}" data-select-num="1" data-shares-on-pages="true"></div>`;
};

enqueteCommand.sharing_multi_enquete = (state, title, startTime, selectNum, ...args) => {
  setSharingScript(state);
  return `<div class="enquete-wrapper" data-title="${escapeHtml(title)}" data-start-time="${escapeHtml(startTime)}" data-enquete-items="${escapeHtml(JSON.stringify(args))}" data-select-num="${escapeHtml(selectNum)}" data-shares-on-pages="true"></div>`;
};

enqueteCommand.sharing_enquete_with_period = (state, title, startTime, endTime, ...args) => {
  setSharingScript(state);
  return `<div class="enquete-wrapper" data-title="${escapeHtml(title)}" data-start-time="${escapeHtml(startTime)}" data-end-time="${escapeHtml(endTime)}" data-enquete-items="${escapeHtml(JSON.stringify(args))}" data-select-num="1" data-shares-on-pages="true"></div>`;
};

enqueteCommand.sharing_multi_enquete_with_period = (state, title, startTime, endTime, selectNum, ...args) => {
  setSharingScript(state);
  return `<div class="enquete-wrapper" data-title="${escapeHtml(title)}" data-start-time="${escapeHtml(startTime)}" data-end-time="${escapeHtml(endTime)}" data-enquete-items="${escapeHtml(JSON.stringify(args))}" data-select-num="${escapeHtml(selectNum)}" data-shares-on-pages="true"></div>`;
};

enqueteCommand.enquete_option = (state, ...args) => {
  const parseJSON = (s) => {
    try {
      return JSON.parse(s);
    } catch (e) {
      console.error(e);
      return null;
    }
  };

  const option = parseJSON(`{ ${args.join(',')} }`);
  if (option === null || !option.title || !option.startTime || !option.items) {
    return '';
  }

  const attrs = [];
  attrs.push(`data-title="${escapeHtml(option.title)}"`);
  attrs.push(`data-select-num="${escapeHtml(option.selectNum ? option.selectNum : '1')}"`);
  attrs.push(`data-order-by="${escapeHtml(option.orderBy ? option.orderBy : 'index')}"`);
  attrs.push(`data-start-time="${escapeHtml(option.startTime)}"`);
  attrs.push(`data-show-vote-percentage="${escapeHtml(option.showVotePercentage ? 'true' : 'false')}"`);
  if (option.endTime) {
    attrs.push(`data-end-time="${escapeHtml(option.endTime)}"`);
  }
  if (option.sharesOnPages) {
    attrs.push('data-shares-on-pages="true"');
  }
  attrs.push(`data-enquete-items="${escapeHtml(JSON.stringify(option.items))}"`);

  setSharingScript(state);
  return `<div class="enquete-wrapper" ${attrs.join(' ')}></div>`;
};

module.exports = enqueteCommand;
